import { createIcon } from '../shared'

const CommentIcon = createIcon(
  ({ color }) => (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.2488 17.6566C21.3008 15.5998 22.5008 13.4578 22.5008 10.9642C22.5008 5.9026 17.8676 1.7998 12.1508 1.7998C6.43398 1.7998 1.80078 5.9026 1.80078 10.9642C1.80078 16.0246 6.58398 19.4998 12.3008 19.4998V21.1786C12.3008 21.7102 12.8528 22.0522 13.3208 21.799C14.7812 21.007 17.4884 19.4194 19.2488 17.6566ZM7.12158 9.7282C7.93878 9.7282 8.60118 10.3858 8.60118 11.1958C8.60118 12.007 7.93878 12.6646 7.12158 12.6646C6.30558 12.6646 5.64438 12.007 5.64438 11.1958C5.64438 10.3846 6.30678 9.7282 7.12158 9.7282ZM13.628 11.1958C13.628 10.3858 12.9668 9.7282 12.1496 9.7282C11.3324 9.7282 10.6712 10.3858 10.6712 11.1958C10.6712 12.007 11.3336 12.6646 12.1496 12.6646C12.9656 12.6646 13.628 12.007 13.628 11.1958ZM17.1776 9.7282C17.9936 9.7282 18.6548 10.3858 18.6548 11.1958C18.6548 12.007 17.9948 12.6646 17.1776 12.6646C16.3604 12.6646 15.698 12.007 15.698 11.1958C15.698 10.3846 16.3604 9.7282 17.1776 9.7282Z"
      fill={color}
    />
  ),
  '0 0 24 24',
  'CommentIcon',
)

export { CommentIcon }
